export const enum ResizeMode {
  Fixed,
  Resize,
  Scale,
  ProportionalScale,
  FillHeight,
}
